/**
 * Normalize MongoDB ObjectId to string - handles string, ObjectId, {$oid: "xxx"}, or {oid: "xxx"}
 */
export const toIdString = (id: any): string => {
    if (id == null) return '';
    if (typeof id === 'string') return id;
    if (typeof id === 'object' && id?.$oid) return id.$oid;
    if (typeof id === 'object' && id?.oid) return id.oid;
    return String(id);
};

/**
 * Helper function to get course data by courseID from an array of courses
 * @param courseDataArray - Array of course objects
 * @param courseID - The courseID to find (string, ObjectId, or {$oid: "xxx"})
 * @returns The course object or undefined if not found
 */
export const getCourseById = (courseDataArray: any[], courseID: any): any => {
    if (!courseDataArray || !Array.isArray(courseDataArray)) {
        console.warn('courseDataArray is not an array:', courseDataArray);
        return undefined;
    }
    
    if (!courseID) {
        console.warn('courseID is undefined or null');
        return courseDataArray[0]; // Fallback to first course
    }
    
    const normalizedId = toIdString(courseID);
    const course = courseDataArray.find((c: any) => 
        toIdString(c._id) === normalizedId
    );
    
    if (!course) {
        console.warn(`Course with ID ${courseID} not found in courseDataArray`);
        return courseDataArray[0]; // Fallback to first course
    }
    
    return course;
};

/**
 * Helper function to get tee set data for a specific player from course data
 * @param courseData - The course object
 * @param teeSetName - The name of the tee set
 * @returns The tee set object or the first tee set as fallback
 */
export const getTeeSetFromCourse = (courseData: any, teeSetName?: string): any => {
    if (!courseData?.teeSets) {
        console.warn('courseData does not have teeSets:', courseData);
        return undefined;
    }
    
    if (!teeSetName) {
        return courseData.teeSets[0];
    }
    
    const teeSet = courseData.teeSets.find((tee: any) => 
        tee.teeName === teeSetName
    );
    
    return teeSet || courseData.teeSets[0];
};

